module.exports = __webpack_public_path__ + "img/apple-store.8de0c47b.svg";